const deTranslation = {
  common: {
    welcome: 'Willkommen',
    login: 'Anmelden',
    logout: 'Abmelden',
    send: 'Senden',
    retry: 'Erneut versuchen',
    loading: 'Laden...',
    error: 'Fehler',
    success: 'Erfolg',
    cancel: 'Abbrechen',
    save: 'Speichern',
    language: 'Sprache',
    newChat: 'Neues Gespräch',
    startingNewChat: 'Neues Gespräch wird gestartet...',
    searchMessage: 'Denken und relevante Informationen analysieren...',
    searchMessageTiming: 'Durchsuchen von Arbeitsanweisungen und Wissenseinträgen...',
    tryAgain: 'Versuch es noch einmal',
    back: 'Zurück',
    goBack: 'Zurückgehen',
    attachDocument: 'Dokument anhängen',
    aiDisclaimer:
      'Antworten werden von AI generiert. Überprüfe wichtige Informationen immer über offizielle Quellen.',
    copyAnswer: 'Antwort kopieren',
    copyMessage: 'Nachricht kopieren',
    copied: 'Kopiert!',
    copyToClipboard: 'In Zwischenablage kopieren',
    expand: 'Erweitern',
    minimize: 'Minimieren',
    showMore: 'Mehr anzeigen',
    noInternalKnowledge: 'Keine interne Wissensbasis gefunden',
    noAdditionalResponse: 'Keine zusätzliche Antwort',
    swapMessage:
      'Wir haben eine firmenspezifische Antwort gefunden. Die allgemeine Antwort ist weiterhin unten verfügbar.',
    toggleShowGeneral: 'Allgemeine Antwort anzeigen (ChatGPT)',
    toggleHideGeneral: 'Allgemeine Antwort ausblenden',
    progressExternal: 'Suche mit ChatGPT…',
    progressInternal: 'Suche in Firmenwissen…',
    internalError: 'Unternehmenswissen derzeit nicht verfügbar.',
    promoteSecondary: 'Als Hauptantwort verwenden',
    compareAnswers: 'Antworten nebeneinander vergleichen',
    switchBack: 'Zurück wechseln',
    generalInformation: 'ChatGPT',
    internalGuidelines: 'Interne Richtlinien',
  },
  knowledge_source: {
    general_info: 'Allgemeine Informationen',
    internal_guidelines: 'Interne Richtlinien',
    internet_results: 'Internetsuchergebnisse',
  },
  errors: {
    assistantResponseContentViolation:
      'Die Antwort des Assistenten verstößt gegen unsere Inhaltsrichtlinien. Bitte versuche es erneut oder formuliere deine Frage um.',
    userInputContentViolation:
      'Deine Anfrage enthält Inhalte, die gegen unsere Inhaltsrichtlinien verstoßen. Bitte formuliere deine Frage um.',
    llmProviderUserInputBlocked:
      'Deine Nachricht wurde vom Inhaltsfilter des KI-Anbieters blockiert. Bitte formuliere deine Frage um.',
    llmProviderBotResponseBlocked:
      'Die KI-Antwort wurde vom Inhaltsfilter des Anbieters blockiert. Bitte versuche es erneut oder formuliere deine Frage um.',
    llmProviderApiError: 'Es gibt Probleme mit unserem KI-Dienst. Bitte versuche es später erneut.',
    serverError:
      'Es ist ein unerwarteter Serverfehler aufgetreten. Bitte versuche es erneut oder kontaktiere den Support, wenn das Problem weiterhin besteht.',
    agentNotFound: 'Der gesuchte Assistent existiert nicht oder ist nicht mehr verfügbar.',
    conversationNotFound: 'Das gesuchte Gespräch existiert nicht oder ist nicht mehr verfügbar.',
    startViolatedPoliciesList: 'Die folgenden Richtlinien wurden verletzt',
    questionTooLong: {
      title: 'Deine Frage ist zu lang',
      description: 'Die maximale Länge beträgt 30.000 Zeichen.',
    },
    excelNotSupportedYet: {
      title: 'Excel- und CSV-Unterstützung kommt bald!',
      description:
        'Wir arbeiten an der Unterstützung von Excel- und CSV-Dateien und sie wird bald verfügbar sein. Bitte verwende vorerst PDF- oder Word-Dateien.',
    },
  },
  auth: {
    welcomeTester: 'Willkommen Kollegin/Kollege',
    welcomeMessage: 'Willkommen bei Cody!',
    loginWithMicrosoft: 'Mit Microsoft anmelden',
    loginInstructions: 'Melde dich mit deinem Microsoft-Konto an, um zu starten.',
  },
  chat: {
    placeholder: 'Stelle hier deine Frage',
    thinking: 'Denken...',
    anonymousUser: 'Anonym',
    howToAskGoodQuestion: 'Wie stellt man eine gute Frage?',
    askQuestion: 'Stelle deine Frage',
    exampleQuestions: 'Beispielfragen',
    tryAsking: 'Versuche zu fragen:',
    assistant: 'Cody, dein digitaler Timing-Assistent',
    welcomeMessage:
      'Hallo {{name}}! Ich bin Cody, dein digitaler Timing-Assistent. Ich kann dir bei Fragen zu Inflow, Retention und/oder Outflow aus den Arbeitsanweisungen und Wissenseinträgen helfen. Was möchtest du wissen?',
    loading: 'Gespräch wird geladen...',
    timingKnowledge: 'TIPP',
    chatgpt: 'ChatGPT',
    internet: 'Internet',
    sensitiveInformationWarning: 'Warnung: Sensibles Thema, zusätzliche Antwortprüfung erforderlich.',
    serverError:
      'Es ist ein unerwarteter Serverfehler aufgetreten. Bitte versuche es erneut oder kontaktiere den Support, wenn das Problem weiterhin besteht.',
    disclaimerText:
      'Antworten werden in Sharepoint gesucht und von AI generiert. Überprüfen Sie die Quellen bei wichtigen Themen.',
  },
  internetSearch: {
    badgeLabel: 'Internetsuche aktiviert',
    badgeTooltip: 'Dieser Assistent kann das Internet durchsuchen',
    inlineWarning:
      'Hinweis: Teile keine unternehmenssensiblen oder persönlichen Daten. Eingaben für die Internetsuche können von Microsoft zum Training verwendet werden.',
    dismiss: 'Verstanden',
    modalTitle: 'Vorsicht bei sensiblen Daten',
    modalBody:
      'Dieser Assistent nutzt Internetsuchen. Teile keine unternehmenssensiblen oder persönlichen Daten. Eingaben können von Microsoft verarbeitet und zum Trainieren von Modellen verwendet werden. Teile nur, was notwendig ist, und folge den Timing-Richtlinien.',
    gotIt: 'Verstanden',
  },
  agentChat: {
    placeholder: 'Gib deine Frage an den Agenten ein...',
    welcomeMessage: 'Hallo, ich bin dein KI-Agent. Wie kann ich heute helfen?',
    privilegedWelcomeMessage: 'Hallo {{userName}}! {{description}}',
    startPrompt: 'Stelle eine Frage, um zu starten',
  },
  profile: {
    settings: 'Einstellungen',
    selectLanguage: 'Wähle deine Sprache',
    appearance: 'Darstellung',
    darkMode: 'Dunkler Modus',
    languageChanged: 'Sprache geändert',
    noEmailAvailable: 'Keine E-Mail verfügbar',
  },
  sidebar: {
    conversations: 'Verlauf',
    assistants: 'Assistenten',
    info: 'Info',
    chatHistory: 'Konversationsverlauf',
    today: 'Heute',
    thisWeek: 'Diese Woche',
    lastWeek: 'Letzte Woche',
    earlier: 'Früher',
    conversation: 'Gespräch',
    noAssistantsAvailable: 'Keine Assistenten verfügbar',
    noContent: 'Kein Inhalt',
    noPreviousConversations: 'Kein vorheriger Verlauf gefunden',
    searchConversations: 'Verlauf durchsuchen...',
    noSearchResults: 'Kein Verlauf entspricht deiner Suche',
    aboutCody: 'Cody, dein digitaler Assistent',
    aboutCodyDescription: 'Cody hilft dir, deine Arbeit angenehmer und einfacher zu machen.',
    dataVisibilityNoticeTitle: 'Hinweis zur Datensichtbarkeit',
    dataVisibilityNoticeBody:
      'Liebe/r Nutzer/in, wenn du Cody aktivierst, können Administratoren Zugriff auf die Inhalte – einschließlich sachlicher Informationen – erhalten, die du teilst. Natürlich haben Kolleginnen/Kollegen und Dritte keinen Zugriff auf die von dir übermittelten Daten und Fragen.',
    bewareDoNotSharePersonalInformation: 'Hinweis: Keine persönlichen Informationen teilen.',
    codyKnowledge:
      'Cody kennt alle Timing-Informationen, die auf TIPP verfügbar sind. Dies sind alle Wissenseinträge und Arbeitsanweisungen zu Inflow, Retention und Outflow.',
    codyGeneralQuestions:
      'Cody kann dir auch bei allgemeinen Fragen helfen, die du ChatGPT stellen oder im Internet finden kannst.',
    noPersonalQuestions: 'Cody kann keine kunden- oder leiharbeiterspezifischen Fragen beantworten.',
    noInTimeQuestions: 'Cody kann keine Fragen zu Informationen auf Intime beantworten, z. B. Nachrichten.',
    askClearQuestions: 'Stelle Cody eine klare Frage, damit er dir gut helfen kann.',
    conversationHistory:
      'Cody berücksichtigt deinen Gesprächsverlauf. Wenn du also eine Anschlussfrage stellen möchtest, ist das möglich.',
    startNewConversation: "Wenn du eine Frage zu einem anderen Thema stellst, klicke am besten auf 'Neues Gespräch'",
    seeHowToAsk: 'siehe: <1>Wie stellt man eine gute Frage?</1> für weitere Tipps',
    aboutAssistants: 'Assistent',
    whereToFindAssistants: 'Gehe zur Bibliothek für eine Übersicht der Assistenten.',
    favorites: 'Favoriten',
    noFavorites: 'Keine Favoriten',
    addFavoritesHint: 'Gehe zur Bibliothek, um Assistenten zu deinen Favoriten hinzuzufügen.',
    whenToUseAssistants:
      "Nutze den 'Guide through Cody' > dieser hilft dir zu bestimmen, wobei Cody dir helfen kann.",
    BewareAssistantsNotAgents:
      'Hinweis: Cody hat Assistenten, keine Agenten. Kurz gesagt: Cody hilft dir bei einzelnen Aufgaben, wenn du darum bittest, z. B. eine E-Mail zusammenfassen. Er sendet die E-Mail jedoch nicht automatisch für dich.',
    feedback: 'Nutze die Daumen unter der Antwort, um Feedback zur Antwort zu geben. Das hilft, Cody zu verbessern!',
    technicalIssuesTitle: 'Technische Probleme oder Verbesserungsvorschlag?',
    technicalIssueLogIn: 'Kannst du dich nicht einloggen oder erhältst du eine Fehlermeldung?',
    technicalIssueImprovementProposal: 'Hast du einen allgemeinen Verbesserungsvorschlag für Cody?',
    technicalISsueAssistants:
      'Hast du einen Verbesserungsvorschlag für einen der Assistenten oder möchtest du einen neuen anfragen?',
    technicalIssueBeta: 'Bitte melde dies im Beta Testers Cody Teams-Chat',
    technicalIssueNonBeta: 'Melde dies, indem du ein Ticket in <1>SSD</1> erstellst',
    loadingPrivilegedAgents: 'Cody wird geladen...',
  },
  feedback: {
    likeAnswer: 'Antwort gefällt mir',
    dislikeAnswer: 'Antwort gefällt mir nicht',
    feedbackSent: 'Dein Feedback wurde gesendet! ✅',
    provideFeedback: 'Feedback zur Frage geben',
    enterFeedback: 'Gib hier dein Feedback ein',
    send: 'Senden',
    reasons: {
      incorrect: 'Antwort ist falsch',
      sourceIncorrect: 'Quelle ist falsch',
      other: 'Andere...',
    },
  },
  instructionModal: {
    title: 'Wie stellt man eine gute Frage?',
    example: 'Beispiel',
  },
  instructions: {
    steps: {
      useFullSentences: {
        title: 'Verwende vollständige Sätze',
        description:
          'Versuche, einen vollständigen Satz zu verwenden, um Missverständnisse zu vermeiden und sofort die bestmögliche Antwort zu erhalten.',
        examples: ['"Wie erstellt man einen Tariftermin" statt "Tariftermin".'],
      },
      noSpecificQuestions: {
        title: 'Keine kunden-/Leiharbeiter-spezifischen Fragen stellen',
        description:
          'Cody kennt nur Arbeitsanweisungen und Wissenseinträge auf TIPP, keine kunden- oder leiharbeiterspezifischen Informationen oder andere Informationen, die nicht auf TIPP zu finden sind.',
        examples: [
          'Frage nicht: "Wie viele Urlaubstage hat John Doe noch?", sondern frage "Wo kann ich sehen, wie viele Urlaubstage mein Leiharbeiter noch hat?"',
        ],
      },
      askOneThingAtATime: {
        title: 'Frage eine Sache nach der anderen',
        description: 'Stelle jeweils nur eine Frage. Das hilft dem Chatbot, gezielte und genaue Antworten zu geben.',
        examples: [
          'Frage nicht "Wie viele Stunden kann ein Leiharbeiter pro Woche arbeiten und wann gilt eine Schicht als Nachtschicht?", sondern stelle diese beiden Fragen nacheinander.',
        ],
      },
    },
    aiAssistant: {
      title: 'Dein KI-Assistent in Teams',
      description:
        'Cody ist eine KI-gestützte Assistentin, die dir mit deinem Wissen hilft. Cody hilft dir bei der Erstellung von E-Mails, Nachrichten, Stellenanzeigen, Präsentationen, Zusammenfassungen, Übersetzungen und mehr.',
      tipTitle: 'Nutzt du die Cody AI (Teams)? Dann beachte die folgenden Punkte:',
      bullets: [
        'Teile niemals persönliche Daten wie Namen und Adressen',
        'Teile niemals vertrauliche Informationen, zum Beispiel zu Kunden oder Geschäften',
        'Überprüfe immer die Quellen, die Cody verwendet',
        'Erstelle keine Inhalte, die sensibel für Timing sind, wie z. B. für Investoren oder Mitarbeiter',
      ],
      flow: {
        title: 'Wie funktioniert der Chatbot?',
        description:
          'Cody beantwortet deine Frage auf Basis der Informationen, die Cody zur Verfügung stehen, der spezifischen Timing-Wissensdatenbank (TIPP). Cody kann auch auf der Basis von Informationen antworten, die von einem Trainingstool wie ChatGPT stammen.',
      },
      funFact: {
        title: 'Fun Fact: So funktioniert Cody',
        description:
          'Cody (LLM) ist eine eigenständige Anwendung, nicht der tatsächliche ChatGPT. Sie besteht aus mehreren Komponenten und einem RAG-Modell, das informiert ist über Inhalte auf TIPP, die mit jeder Frage durchsucht werden.',
      },
    },
    chat: {
      title: 'Chat mit Cody',
      description: 'Um die beste Antwort zu erhalten, denke zuerst darüber nach, was du wissen möchtest.',
      steps: [
        {
          title: 'Sei konkret',
          description:
            'Es ist besser, "Wie bewirb ich mich um Urlaub für meinen Leiharbeiter?" zu fragen als "Ferienfragen".',
        },
        {
          title: 'Beschreibe den Kontext',
          description:
            'Die Antwort fällt besser aus, wenn Cody die Details versteht. Welche Rolle spielst du? Was versuchst du zu erreichen?',
        },
        {
          title: 'Teile ausreichend Informationen',
          description: 'Denke daran, relevante Beispiele, Einschränkungen und Hintergrunddetails zu teilen.',
        },
        {
          title: 'Überprüfe die Antwort',
          description: 'Falls etwas unklar oder falsch ist, stelle eine Anschlussfrage.',
        },
      ],
    },
    examples: {
      title: 'Beispielfragen',
      subtitle: 'Hier sind einige Beispielanfragen, um dir den Einstieg zu erleichtern',
      items: [
        'Ich bekomme eine Fehlermeldung, wenn ich mich in Intime anmelde. Was soll ich tun?',
        'Wie kann ich Nachrichten in der Bibliothek hinzufügen?',
        'Hilfe! Ich habe versehentlich eine falsch verbuchte Zeitstempel eingereicht.',
        'Meine Kollegin/Leiharbeiter möchte Zugang zum Chatbot. Wie kann ich das einrichten?',
        'Was sind die wichtigsten Schritte bei einem Onboarding mit einem externen Mitarbeiter?',
      ],
    },
  },
  conversations: {
    noAssistantsMessage: 'Sieht so aus, als wäre keine Bibliothek eingerichtet. Bitte wende dich an den Support.',
    searchPlaceholder: 'Gespräche durchsuchen',
    newChat: 'Neues Gespräch',
    untitledConversation: 'Gespräch ohne Titel',
    emptyStateTitle: 'Keine Gespräche',
    emptyStateDescription: 'Du hast noch keine Gespräche.',
    delete: 'Löschen',
    share: 'Teilen',
    rename: 'Umbenennen',
    copyLink: 'Link kopieren',
    copiedLink: 'Gesprächslink kopiert!',
    deleteWarning: 'Bist du sicher? Dieser Chat wird dauerhaft gelöscht.',
    deleteFailed: 'Löschen des Chats fehlgeschlagen',
    deleteSuccess: 'Chat gelöscht',
  },
  homePage: {
    title: 'Chat mit Cody',
    subtitle: 'Cody ist ein Chatbot, der auf Timing-Wissen zu Inflow, Retention und Outflow spezialisiert ist.',
    newChat: 'Neues Gespräch',
    search: 'Suche',
    feedback: 'Feedback',
    seeExamples: 'Beispiele anzeigen',
    featuredTopics: 'Empfohlene Themen',
    startWithTopic: 'Starte mit einem Thema',
    appFeatures: 'App-Funktionen',
    libraryInformation: 'Bibliotheksinformationen',
  },
  search: {
    noResults: 'Keine Ergebnisse gefunden',
    tryDifferentQuery: 'Versuche eine andere Anfrage oder suche nach einem anderen Stichwort',
  },
  share: {
    inviteColleagues: 'Lade Kolleginnen/Kollegen ein, Cody auszuprobieren',
    and: 'und',
    shareConversations: 'Teile deine Gespräche mit anderen',
    sharePublic: 'Mit Link teilen',
    shareTeams: 'In Teams teilen',
    shareCopy: 'Kopieren',
    shared: 'Geteilt',
  },
  profilePage: {
    personalInformation: 'Persönliche Informationen',
    fullName: 'Vollständiger Name',
    email: 'E-Mail',
    accountId: 'Konto-ID',
    role: 'Rolle',
    language: 'Sprache',
    memberSince: 'Mitglied seit',
  },
  assistantLibrary: {
    title: 'Assistentenbibliothek',
    subtitle: 'Wähle einen Assistenten, um loszulegen',
    searchPlaceholder: 'Assistenten suchen...',
    category: 'Kategorie',
    allCategories: 'Alle Kategorien',
    sortBy: 'Sortieren nach',
    createdAt: 'Erstellt am',
    updatedAt: 'Aktualisiert am',
    name: 'Name',
    description: 'Beschreibung',
    mostPopular: 'Am beliebtesten',
    myFavorites: 'Meine Favoriten',
    results: 'Ergebnisse',
    result: 'Ergebnis',
    noResultsFound: 'Keine Assistenten gefunden',
    assistantCard: {
      created: 'Erstellt',
      updated: 'Aktualisiert',
      cta: 'Chat starten',
    },
    filters: {
      reset: 'Zurücksetzen',
      showFilters: 'Filter anzeigen',
      hideFilters: 'Filter ausblenden',
    },
  },
  libraryBanner: {
    title: 'Willkommen in der Assistentenbibliothek',
    description:
      'Hier findest du spezialisierte Assistenten für unterschiedliche Bedürfnisse, einschließlich HR-Compliance, technische Unterstützung, Benutzerschulungen, Datenanalysen und mehr.',
    readyToChat: 'Bereit zum Chatten?',
    browseAssistants: 'Assistenten durchsuchen',
  },
  assistant: {
    welcomeTitle: 'Willkommen bei {{name}}',
    welcomeMessage: 'Gib deine Frage ein oder wähle eine der Beispielanfragen unten aus, um zu starten.',
    conversations: 'Gespräche',
    settings: 'Einstellungen',
    description: 'Beschreibung',
    noDescription: 'Keine Beschreibung verfügbar',
    exampleQuestions: 'Beispielfragen',
    createdAt: 'Erstellt am',
    updatedAt: 'Aktualisiert am',
    createdBy: 'Erstellt von',
    timezone: 'Zeitzone',
    language: 'Sprache',
    public: 'Öffentlich',
    private: 'Privat',
    knowledgeSource: 'Wissensquelle',
    noKnowledgeSource: 'Keine Wissensquelle angegeben',
    chat: 'Chat',
    prompts: 'Prompts',
    files: 'Dateien',
    instructions: 'Anweisungen',
    loading: 'Assistent wird geladen...',
    loadFailed: 'Assistent konnte nicht geladen werden',
    retry: 'Erneut versuchen',
    startChat: 'Chat starten',
    startNewChat: 'Neuen Chat beginnen',
    inputPlaceholder: 'Gib deine Nachricht ein...',
    uploadFile: 'Datei hochladen',
    fileUploaded: 'Datei hochgeladen',
    fileRemoved: 'Datei entfernt',
    fileUploadError: 'Fehler beim Hochladen der Datei',
    fileRemoveError: 'Fehler beim Entfernen der Datei',
    fileTooLarge: 'Datei ist zu groß',
    fileTooLargeDescription: 'Maximale Dateigröße ist 10 MB',
    fileTypeNotAllowed: 'Dateityp nicht erlaubt',
    fileTypeNotAllowedDescription: 'Erlaubte Dateitypen: PDF, DOCX, TXT',
    send: 'Senden',
    sending: 'Senden...',
    messageSent: 'Nachricht gesendet',
    messageFailed: 'Senden der Nachricht fehlgeschlagen',
    newMessage: 'Neue Nachricht',
    clearChat: 'Chat löschen',
    confirmClearChat:
      'Bist du sicher, dass du den Chat löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
    chatCleared: 'Chat gelöscht',
    chatClearFailed: 'Löschen des Chats fehlgeschlagen',
    copyConversation: 'Gespräch kopieren',
    conversationCopied: 'Gespräch kopiert',
    copyFailed: 'Kopieren fehlgeschlagen',
    feedback: 'Feedback',
    submitFeedback: 'Feedback senden',
    feedbackSent: 'Feedback gesendet',
    feedbackFailed: 'Senden des Feedbacks fehlgeschlagen',
    feedbackPlaceholder: 'Wie war deine Erfahrung?',
    ratingRequired: 'Bitte wähle eine Bewertung',
    optional: 'Optional',
    required: 'Erforderlich',
  },
  assistantSettings: {
    title: 'Assistenteneinstellungen',
    description: 'Passe die Konfiguration deines Assistenten an',
    tabs: {
      general: 'Allgemein',
      permissions: 'Berechtigungen',
      knowledge: 'Wissen',
      behavior: 'Verhalten',
    },
    save: 'Einstellungen speichern',
    saved: 'Einstellungen gespeichert',
    saveError: 'Fehler beim Speichern der Einstellungen',
  },
  assistantGeneral: {
    title: 'Allgemeine Einstellungen',
    name: 'Name',
    description: 'Beschreibung',
    timezone: 'Zeitzone',
    language: 'Sprache',
    visibility: 'Sichtbarkeit',
    public: 'Öffentlich',
    private: 'Privat',
    save: 'Speichern',
    saved: 'Gespeichert',
    saveError: 'Fehler beim Speichern',
  },
  assistantPermissions: {
    title: 'Berechtigungen',
    addUser: 'Benutzer hinzufügen',
    addGroup: 'Gruppe hinzufügen',
    searchUsers: 'Benutzer suchen',
    searchGroups: 'Gruppen suchen',
    invite: 'Einladen',
    invited: 'Eingeladen',
    inviteError: 'Fehler beim Einladen',
    remove: 'Entfernen',
    removed: 'Entfernt',
    removeError: 'Fehler beim Entfernen',
    access: 'Zugriff',
    accessLevels: {
      owner: 'Besitzer',
      editor: 'Bearbeiter',
      viewer: 'Betrachter',
    },
  },
  assistantKnowledge: {
    title: 'Wissensquelle',
    addSource: 'Quelle hinzufügen',
    searchSources: 'Quellen durchsuchen',
    upload: 'Hochladen',
    uploaded: 'Hochgeladen',
    uploadError: 'Fehler beim Hochladen',
    remove: 'Entfernen',
    removed: 'Entfernt',
    removeError: 'Fehler beim Entfernen',
    sourceType: 'Quelltyp',
    sourceTypes: {
      document: 'Dokument',
      url: 'URL',
      database: 'Datenbank',
    },
  },
  assistantBehavior: {
    title: 'Verhalten',
    instructions: 'Anweisungen',
    addInstruction: 'Anweisung hinzufügen',
    model: 'Modell',
    temperature: 'Temperatur',
    maxTokens: 'Maximale Tokens',
    topP: 'Top P',
    frequencyPenalty: 'Häufigkeitsstrafe',
    presencePenalty: 'Präsenzstrafe',
    reset: 'Zurücksetzen',
    resetConfirm: 'Möchtest du dieses Verhalten wirklich auf die Standardwerte zurücksetzen?',
    resetSuccess: 'Verhalten zurückgesetzt',
    resetFailed: 'Zurücksetzen fehlgeschlagen',
  },
  promptTemplates: {
    title: 'Prompt-Vorlagen',
    subtitle: 'Erstelle und verwalte wiederverwendbare Prompts',
    create: 'Vorlage erstellen',
    edit: 'Vorlage bearbeiten',
    delete: 'Vorlage löschen',
    name: 'Name',
    description: 'Beschreibung',
    content: 'Inhalt',
    created: 'Vorlage erstellt',
    updated: 'Vorlage aktualisiert',
    deleted: 'Vorlage gelöscht',
    creationError: 'Fehler beim Erstellen der Vorlage',
    updateError: 'Fehler beim Aktualisieren der Vorlage',
    deletionError: 'Fehler beim Löschen der Vorlage',
    deleteConfirmTitle: 'Vorlage löschen',
    deleteConfirmMessage: 'Bist du sicher, dass du diese Vorlage löschen möchtest?',
    deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  },
  promptForm: {
    name: 'Name',
    namePlaceholder: 'Gib den Vorlagennamen ein',
    nameHelp: 'Wähle einen aussagekräftigen Namen für deine Vorlage',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Gib die Vorlagenbeschreibung ein',
    descriptionHelp: 'Kurzer Überblick über den Zweck der Vorlage',
    content: 'Inhalt',
    contentPlaceholder: 'Gib den Prompt-Inhalt ein',
    contentHelp: 'Verwende Variablen wie {{name}} und {{context}}',
    save: 'Vorlage speichern',
    saving: 'Speichern...',
    saved: 'Vorlage gespeichert',
    saveError: 'Fehler beim Speichern der Vorlage',
  },
  agentBuilder: {
    back: 'Zurück',
    next: 'Weiter',
    saveAsDraft: 'Als Entwurf speichern',
    saveAndFinish: 'Speichern & beenden',
    launchAssistant: 'Assistent starten',
    previous: 'Zurück',
    continue: 'Weiter',
    cancel: 'Abbrechen',
  },
  createAgent: {
    title: 'Assistent erstellen',
    subtitle: 'Konfiguriere deinen neuen KI-Assistenten',
    name: 'Name',
    description: 'Beschreibung',
    language: 'Sprache',
    timezone: 'Zeitzone',
    visibility: 'Sichtbarkeit',
    public: 'Öffentlich',
    private: 'Privat',
    next: 'Weiter',
    back: 'Zurück',
    create: 'Assistent erstellen',
    creating: 'Erstellen...',
    created: 'Assistent erstellt',
    createError: 'Fehler beim Erstellen des Assistenten',
    required: 'Dieses Feld ist erforderlich',
  },
  agentAppearance: {
    title: 'Aussehen',
    subtitle: 'Passe das Erscheinungsbild deines Assistenten an',
    icon: 'Symbol',
    color: 'Farbe',
    iconHelp: 'Wähle ein Symbol, das zu deiner Marke passt',
    colorHelp: 'Wähle eine Farbe für die Assistentenschnittstelle',
  },
  agentBehavior: {
    title: 'Verhalten',
    subtitle: 'Steuere, wie dein Assistent reagiert',
    systemPrompt: 'System-Prompt',
    systemPromptHelp: 'Leite den Ton und die Persönlichkeit deines Assistenten',
    guardrails: 'Leitplanken',
    guardrailsHelp: 'Definiere, was dein Assistent nicht tun sollte',
    temperature: 'Temperatur',
    maxTokens: 'Maximale Tokens',
    topP: 'Top P',
    frequencyPenalty: 'Häufigkeitsstrafe',
    presencePenalty: 'Präsenzstrafe',
  },
  agentKnowledge: {
    title: 'Wissen',
    subtitle: 'Verbinde Wissensquellen mit deinem Assistenten',
    uploadFiles: 'Dateien hochladen',
    addLinks: 'Links hinzufügen',
    addText: 'Text hinzufügen',
    upload: 'Hochladen',
    uploading: 'Hochladen...',
    uploaded: 'Hochgeladen',
    uploadError: 'Fehler beim Hochladen',
    remove: 'Entfernen',
    removed: 'Entfernt',
    removeError: 'Fehler beim Entfernen',
    maxFiles: 'Maximal 10 Dateien',
    maxSize: 'Bis zu 10 MB pro Datei',
    supportedFormats: 'PDF, DOCX, TXT',
  },
  agentPreview: {
    title: 'Vorschau',
    subtitle: 'Teste deinen Assistenten, bevor du ihn startest',
    welcomeMessage: 'Willkommen! Ich bin dein neuer Assistent. Wie kann ich helfen?',
    inputPlaceholder: 'Gib eine Nachricht ein...',
    send: 'Senden',
  },
  agentReview: {
    title: 'Überprüfen & starten',
    subtitle: 'Überprüfe deine Einstellungen, bevor du den Assistenten startest',
    launch: 'Assistent starten',
    launching: 'Startet...',
    launched: 'Gestartet',
    launchError: 'Fehler beim Starten des Assistenten',
  },
  agentValidation: {
    nameRequired: 'Name ist erforderlich',
    descriptionRequired: 'Beschreibung ist erforderlich',
    languageRequired: 'Sprache ist erforderlich',
    timezoneRequired: 'Zeitzone ist erforderlich',
  },
  assistantFilters: {
    title: 'Filter',
    clearAll: 'Alle löschen',
    apply: 'Anwenden',
    createdAt: 'Erstellt am',
    updatedAt: 'Aktualisiert am',
    visibility: 'Sichtbarkeit',
    all: 'Alle',
    public: 'Öffentlich',
    private: 'Privat',
  },
  timezones: {
    search: 'Zeitzonen suchen...',
    noResults: 'Keine Zeitzonen gefunden',
  },
  languages: {
    search: 'Sprachen suchen...',
    noResults: 'Keine Sprachen gefunden',
  },
  alerts: {
    successTitle: 'Erfolg',
    errorTitle: 'Fehler',
    warningTitle: 'Warnung',
    infoTitle: 'Info',
  },
  validation: {
    required: 'Dieses Feld ist erforderlich',
    invalidEmail: 'Ungültige E-Mail-Adresse',
    minLength: 'Mindestlänge {{count}} Zeichen',
    maxLength: 'Maximale Länge {{count}} Zeichen',
  },
  date: {
    today: 'Heute',
    yesterday: 'Gestern',
    daysAgo: 'vor {{count}} Tagen',
  },
  attachments: {
    dropFiles: 'Dateien zum Hochladen hier ablegen',
    browse: 'Durchsuchen',
    uploading: 'Hochladen...',
    upload: 'Hochladen',
    uploaded: 'Hochgeladen',
    uploadError: 'Fehler beim Hochladen',
    remove: 'Entfernen',
    removed: 'Entfernt',
    removeError: 'Fehler beim Entfernen',
  },
  prompts: {
    title: 'Prompts',
    subtitle: 'Verwalte Prompt-Vorlagen und Voreinstellungen',
    create: 'Prompt erstellen',
    edit: 'Prompt bearbeiten',
    delete: 'Prompt löschen',
    name: 'Name',
    description: 'Beschreibung',
    content: 'Inhalt',
    created: 'Prompt erstellt',
    updated: 'Prompt aktualisiert',
    deleted: 'Prompt gelöscht',
    creationError: 'Fehler beim Erstellen des Prompts',
    updateError: 'Fehler beim Aktualisieren des Prompts',
    deletionError: 'Fehler beim Löschen des Prompts',
    deleteConfirmTitle: 'Prompt löschen',
    deleteConfirmMessage: 'Bist du sicher, dass du diesen Prompt löschen möchtest?',
    deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  },
  promptEditor: {
    title: 'Prompt-Editor',
    subtitle: 'Erstelle und bearbeite deine Prompts',
    save: 'Prompt speichern',
    saved: 'Prompt gespeichert',
    saveError: 'Fehler beim Speichern des Prompts',
    variables: 'Variablen',
    addVariable: 'Variable hinzufügen',
    variableName: 'Variablenname',
    variablePlaceholder: 'Gib den Variablennamen ein',
    variableExample: 'Beispiel: name, context, date',
    removeVariable: 'Variable entfernen',
  },
  promptPresets: {
    title: 'Prompt-Voreinstellungen',
    subtitle: 'Wähle aus vordefinierten Prompt-Einstellungen',
    systemPrompts: 'System-Prompts',
    userPrompts: 'Benutzer-Prompts',
    assistantPrompts: 'Assistenten-Prompts',
    tone: 'Ton',
    tones: {
      professional: 'Professionell',
      casual: 'Locker',
      friendly: 'Freundlich',
      formal: 'Formal',
    },
    style: 'Stil',
    styles: {
      concise: 'Knapp',
      detailed: 'Detailliert',
      persuasive: 'Überzeugend',
      informative: 'Informativ',
    },
  },
  knowledge: {
    title: 'Wissensquellen',
    subtitle: 'Verwalte Datenquellen für deine Assistenten',
    addSource: 'Quelle hinzufügen',
    searchSources: 'Quellen durchsuchen',
    sourceType: 'Quelltyp',
    sourceTypes: {
      document: 'Dokument',
      url: 'URL',
      database: 'Datenbank',
    },
    status: 'Status',
    statuses: {
      processing: 'Wird verarbeitet',
      ready: 'Bereit',
      failed: 'Fehlgeschlagen',
    },
    lastUpdated: 'Zuletzt aktualisiert',
    actions: 'Aktionen',
    view: 'Anzeigen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    deleteConfirm: 'Bist du sicher, dass du diese Quelle löschen möchtest?',
    deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  },
  knowledgeForm: {
    title: 'Wissensquelle hinzufügen',
    sourceType: 'Quelltyp',
    name: 'Name',
    description: 'Beschreibung',
    url: 'URL',
    file: 'Datei',
    status: 'Status',
    submit: 'Einreichen',
    submitting: 'Einreichen...',
    submitted: 'Eingereicht',
    submitError: 'Fehler beim Einreichen der Quelle',
  },
  knowledgeStatus: {
    processing: 'Wird verarbeitet',
    ready: 'Bereit',
    failed: 'Fehlgeschlagen',
  },
  behavior: {
    title: 'Verhalten',
    systemPrompt: 'System-Prompt',
    instructions: 'Anweisungen',
    temperature: 'Temperatur',
    maxTokens: 'Maximale Tokens',
    topP: 'Top P',
    frequencyPenalty: 'Häufigkeitsstrafe',
    presencePenalty: 'Präsenzstrafe',
    save: 'Speichern',
    saved: 'Gespeichert',
    saveError: 'Fehler beim Speichern',
  },
  placeholders: {
    search: 'Suche...',
    enterText: 'Text eingeben...',
    enterName: 'Namen eingeben...',
    enterDescription: 'Beschreibung eingeben...',
  },
  roles: {
    owner: 'Besitzer',
    admin: 'Admin',
    editor: 'Bearbeiter',
    viewer: 'Betrachter',
  },
  pagination: {
    previous: 'Zurück',
    next: 'Weiter',
    page: 'Seite',
    of: 'von',
  },
  emptyStates: {
    noData: 'Keine Daten verfügbar',
    noResults: 'Keine Ergebnisse',
    noAccess: 'Kein Zugriff',
  },
  filters: {
    apply: 'Anwenden',
    reset: 'Zurücksetzen',
    clear: 'Leeren',
    sort: 'Sortieren',
    filter: 'Filter',
  },
  breadcrumbs: {
    home: 'Startseite',
    back: 'Zurück',
  },
  tags: {
    addTag: 'Tag hinzufügen',
    add: 'Hinzufügen',
    remove: 'Entfernen',
    required: 'Mindestens ein Tag ist erforderlich',
    tagsHelp: 'Tags helfen dabei, deinen Assistenten zu organisieren und zu kategorisieren',
    exampleQuestions: 'Beispielfragen',
    exampleQuestionsHelp: 'Füge Beispielfragen hinzu, die Nutzer anklicken können, um ein Gespräch zu starten',
  },
  editAgent: {
    title: 'Assistent bearbeiten',
    subtitle: 'Passe die Einstellungen und das Verhalten deines KI-Assistenten an',
    updateAgent: 'Assistent aktualisieren',
    deleteAgent: 'Assistent löschen',
    updating: 'Aktualisiere...',
    deleting: 'Lösche...',
    agentUpdated: 'Assistent aktualisiert',
    updatedSuccessfully: 'wurde erfolgreich aktualisiert',
    updateError: 'Aktualisierungsfehler',
    updateErrorDescription:
      'Beim Aktualisieren des Assistenten ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    agentDeleted: 'Assistent gelöscht',
    deletedSuccessfully: 'wurde erfolgreich gelöscht',
    deleteError: 'Löschfehler',
    deleteErrorDescription: 'Beim Löschen des Assistenten ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    deleteConfirmTitle: 'Assistent löschen',
    deleteConfirmMessage:
      'Bist du sicher, dass du diesen Assistenten löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
    confirmDelete: 'Ja, löschen',
    loadingAgent: 'Assistentendetails werden geladen...',
    failedToLoad: 'Assistentendetails konnten nicht geladen werden',
  },
  jobCategory: {
    addNew: 'Kategorie hinzufügen',
    name: 'Name',
    nameRequired: 'Kategoriename ist erforderlich',
    enterName: 'Gib den Kategorienamen ein...',
    create: 'Erstellen',
    edit: 'Bearbeiten',
    update: 'Aktualisieren',
    delete: 'Löschen',
    created: 'Kategorie erstellt',
    createdSuccessfully: 'wurde erfolgreich erstellt',
    updated: 'Kategorie aktualisiert',
    updatedSuccessfully: 'wurde erfolgreich aktualisiert',
    deleted: 'Kategorie gelöscht',
    deletedSuccessfully: 'wurde erfolgreich gelöscht',
    creationError: 'Fehler beim Erstellen',
    creationErrorDescription: 'Beim Erstellen der Kategorie ist ein Fehler aufgetreten',
    updateError: 'Aktualisierungsfehler',
    updateErrorDescription: 'Beim Aktualisieren der Kategorie ist ein Fehler aufgetreten',
    deletionError: 'Löschfehler',
    deletionErrorDescription: 'Beim Löschen der Kategorie ist ein Fehler aufgetreten',
    deleteError: 'Löschfehler',
    deleteErrorDescription: 'Beim Löschen der Kategorie ist ein Fehler aufgetreten',
    deleteConfirmTitle: 'Kategorie löschen',
    deleteConfirmMessage: 'Bist du sicher, dass du "{{name}}" löschen möchtest?',
    deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden und kann bestehende Assistenten beeinflussen.',
    warning: 'Warnung',
    agentsWillLoseCategory: 'Assistenten verlieren ihre Kategoriezuordnung',
  },
  languageNames: {
    en: 'Englisch',
    nl: 'Niederländisch',
    de: 'Deutsch',
    fr: 'Französisch',
    it: 'Italienisch',
    pl: 'Polnisch',
  },
  iconSelector: {
    chooseIcon: 'Symbol auswählen',
  },
}

const clientDefaults = {
  fallbackAgentDescription: 'AI Assistent für Unternehmenskenntnisse von AHV International.',
}

export default { ...deTranslation, ...clientDefaults }
